import { useCallback, useEffect, useState } from 'react';
import { ANALYTICS_EVENTS } from '../../common/constants';
import useAnalyticsContext from './useAnalyticsContext';

export default function useGoogleOneTap(gAppId, hasLoggedIn) {
  const [oneTapLoginPayload, setOneTapLoginPayload] = useState();
  const analytics = useAnalyticsContext();
  const { google } = typeof window === 'undefined' ? {} : window;

  const initializeCallback = useCallback((response) => {
    setOneTapLoginPayload(response);
  }, []);

  useEffect(() => {
    if (google?.accounts) {
      google.accounts.id.initialize({
        client_id: `${gAppId}.apps.googleusercontent.com`,
        callback: initializeCallback,
      });

      // show prompt UI if no user has been found
      if (!hasLoggedIn) {
        google.accounts.id.prompt((notification) => {
          // Record if OneTap was displayed to the user
          if (notification.isDisplayed()) {
            analytics.tagEvent({ name: ANALYTICS_EVENTS.GOOGLE_ONETAP_IMPRESSION });
          }

          // Record if the user gave consent to authenticate
          if (notification.getDismissedReason() === 'credential_returned') {
            analytics.tagEvent({ name: ANALYTICS_EVENTS.GOOGLE_ONETAP_CLICKED });
          }
        });
      }
    }
  }, [analytics, gAppId, google, hasLoggedIn, initializeCallback]);

  return oneTapLoginPayload?.credential;
}
